module.exports = __webpack_public_path__ + "img/tuboDreno2.202d626c.png";